<template>
  <div :class="{ 'transport-routes-wrap': true }">
    <div class="tab-cont">
      <div class="tab-cont-top">
        <div class="tab-tag-wrap">
          <el-radio v-model="transportType" label border>{{$t('texts.all')}}</el-radio>
          <el-radio v-model="transportType" label="空运" border>{{$t('texts.flightTransport')}}</el-radio>
          <el-radio v-model="transportType" label="铁运" border>{{$t('texts.trainTransport')}}</el-radio>
        </div>
        <a class="show-more">
          <span>{{$t('actions.viewAllTransports')}}</span>
          <img class="arrow-icon" src="http://rs.cms-zmb.omszt.com/cms/other/1666174281968下2.png" />
        </a>
      </div>
      <el-carousel
        v-if="showListData && showListData.length"
        :autoplay="false"
        trigger="click"
        height="810px"
      >
        <el-carousel-item v-for="(itemList, itemListIdx) in showListData" :key="itemListIdx">
          <div v-if="itemList && itemList.length" class="grid-wrap-box">
            <div v-for="(item, itemIdx) in itemList" :key="itemIdx" class="box_8 flex-col">
              <span class="text_17">{{ item['名称'] }}</span>
              <div class="box_76 flex-row justify-between">
                <div class="text-wrapper_4 flex-col">
                  <span class="text_18">{{$t('texts.transportCode')}}: {{ item['渠道代码'] }}</span>
                </div>
              </div>
              <div class="text-wrapper_50 flex-row">
                <span class="text_20">{{$t('texts.transportDays')}}</span>
                <span class="text_21">{{ item['时效'] }}</span>
                <span class="text_22">{{$t('texts.transportLine')}}</span>
                <span class="text_23">{{ item['国家'] }}</span>
                <span class="text_24">{{$t('texts.transportType')}}</span>
                <span class="text_25">{{ item['运输方式'] }}</span>
              </div>
              <div class="text-wrapper_51 flex-row justify-between">
                <span class="text_26">{{$t('texts.serviceType')}}</span>
                <span class="text_27">{{ item['服务类型'] }}</span>
              </div>
              <div class="box_77 flex-row">
                <div class="flex-row">
                  <div class="text-wrapper_8" v-if="item['价格'].length === 2">
                    <span class="text_28">￥</span>
                    <span class="text_29">{{ item['价格'][0] }}</span>
                    <span class="text_30" v-if="item['价格'][1]">.</span>
                    <span class="text_31">{{ item['价格'][1] }}/KG</span>
                  </div>
                  <div class="text-wrapper_8" v-if="item['价格'].length !== 2">
                    <span style="font-size: 15px;" class="text_31">{{ item['价格'] }}</span>
                  </div>
                  <span v-if="item['价格'].length === 2" class="text_32">{{$t('texts.priceStart')}}</span>
                </div>
                <div class="flex-row">
                  <div @click="openWxChatView" class="group_5 flex-col"></div>
                  <div @click="openWxChatView" class="text-wrapper_9 flex-col">
                    <span class="text_33">{{$t('actions.viewTransport')}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <el-dialog append-to-body v-model="dialogTableVisible">
      <template #default>
        <div v-if="dialogTableVisible" class="new-detail-item-cont" v-html="articleContent.content"></div>
      </template>
      <template #footer>
        <el-button type="primary" @click="()=>dialogTableVisible = false">{{$t('actions.close')}}</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, computed } from "vue";
import { getArticleDetails } from "@/api";
import { $t } from "~/utils/index.js";

const dialogTableVisible = ref(false);
const transportType = ref("");
const tabsData = reactive([
  {
    名称: "福州直飞台湾（普货）",
    国家: "中国台湾",
    服务类型: "头程服务",
    运输方式: "空运",
    时效: "2天",
    渠道代码: "XF001",
    货物类型: "普货",
    价格: ["12", "5"]
  },
  {
    名称: "香港直飞台湾（特货）",
    国家: "中国台湾",
    服务类型: "头程服务",
    运输方式: "空运",
    时效: "2天",
    渠道代码: "ZMB001",
    货物类型: "特货",
    价格: ["16", "5"]
  },
  {
    名称: "邮政EMS-日本（普货）",
    国家: "日本",
    服务类型: "空派服务",
    运输方式: "空运",
    时效: "3-5天",
    渠道代码: "XF002",
    货物类型: "普货",
    价格: ["20", ""]
  },
  {
    名称: "邮政EMS-日本（特货）",
    国家: "日本",
    服务类型: "空派服务",
    运输方式: "空运",
    时效: "6-7天",
    渠道代码: "XF003",
    货物类型: "特货",
    价格: ["26", "5"]
  },
  {
    名称: "邮政水包-日本",
    国家: "日本",
    服务类型: "海派服务",
    运输方式: "海运",
    时效: "25-35天",
    渠道代码: "XF004",
    货物类型: "普货",
    价格: "首重77元/KG,续重9.8元/KG起"
  },
  {
    名称: "自营-加拿大（普货）",
    国家: "加拿大",
    服务类型: "空派服务",
    运输方式: "空运",
    时效: "7天",
    渠道代码: "ZMB002",
    货物类型: "普货",
    价格: ["67", ""]
  },
  {
    名称: "自营-加拿大（特货）",
    国家: "加拿大",
    服务类型: "空派服务",
    运输方式: "空运",
    时效: "7天",
    渠道代码: "ZMB003",
    货物类型: "特货",
    价格: ["71", ""]
  },
  {
    名称: "邮政EMS-澳洲（普货）",
    国家: "澳洲",
    服务类型: "空派服务",
    运输方式: "空运",
    时效: "7-9天",
    渠道代码: "XF005",
    货物类型: "普货",
    价格: ["57", ""]
  },
  {
    名称: "邮政EMS-澳洲（特货）",
    国家: "澳洲",
    服务类型: "空派服务",
    运输方式: "空运",
    时效: "7-9天",
    渠道代码: "XF006",
    货物类型: "特货",
    价格: ["59", ""]
  },
  {
    名称: "自营-日本进口",
    国家: "中国",
    服务类型: "空派服务",
    运输方式: "空运",
    时效: "15天",
    渠道代码: "ZMB004",
    货物类型: "普/特货",
    价格: "首重75元/KG,续重36元/0.5KG起"
  },
  {
    名称: "邮政散货渠道（普货）",
    国家: "中国-其他国家",
    服务类型: "空派服务",
    运输方式: "空运",
    时效: "7-9天",
    渠道代码: "XF008",
    货物类型: "普货",
    价格: "首重37.8元/0.5KG,续重8.4元/0.5KG起"
  },
  {
    名称: "中欧班列",
    国家: "中国-其他国家",
    服务类型: "铁运服务",
    运输方式: "铁运",
    时效: "40-50天",
    渠道代码: "ZMB001",
    货物类型: "普货",
    价格: ["37", "5"]
  }
]);
const articleContent = ref("");

const getArticleContent = async () => {
  
  const param = {
    pageNo: 0,
    pageSize: 9999,
    id: "795699230351114240",
    status: "1"
  };
  const res = await getArticleDetails(param);
  if (res.data.dataList) {
    articleContent.value = res.data.dataList[0];
    if (articleContent.value.type === 1 && articleContent.value.content) {
      articleContent.value.content = articleContent.value.content.replace(
        "video",
        "video autoplay "
      );
    }
  }
};
 
 

// 初始化时获取文章内容
onMounted(() => {
  getArticleContent();
});

const showListData = computed(() => {
  let res = [];
  try {
    let orgRes = tabsData;
    if (transportType.value) {
      orgRes = orgRes.filter(o => {
        return o["运输方式"] == transportType.value;
      });
    }
    for (let i = 0; i < orgRes.length; ) {
      res.push(orgRes.slice(i, (i += 6)));
    }
  } catch (e) {}
  return res;
});

 

const openWxChatView = () => {
  dialogTableVisible.value = true;
};
</script>

<style scoped>
.transport-routes-wrap .flex-col{
  display: flex;
  flex-direction: column;
}
.transport-routes-wrap .flex-row{
  display: flex;
  flex-direction: row;
}
.transport-routes-wrap {
  width: 1640px;
  margin: 0 auto;
}

.transport-routes-wrap :deep(.el-carousel__indicators .el-carousel__button) {
  background-color: #d8d8d8;
  border-radius: 2px;
  height: 4px;
}

.transport-routes-wrap
  :deep(.el-carousel__indicators .is-active .el-carousel__button) {
  background-color: #ff6a76;

  background: linear-gradient(180deg, #f50029 0%, #ff6a76 100%);
}

.grid-wrap-box {
  display: flex;
  justify-content: space-between;
  margin-top: 47px;
  flex-wrap: wrap;
}

.transport-routes-wrap :deep(.el-tabs .el-tabs__nav-wrap::after) {
  height: 1px;
  background-color: #e0e0e0;
}

.transport-routes-wrap :deep(.el-tabs__nav-scroll) {
  display: flex;
  justify-content: center;
}

.transport-routes-wrap :deep(.el-tabs__item) {
  font-size: 28px;
  height: 64px;
  padding: 0 196px;
}

.transport-routes-wrap :deep(.el-tabs__item.is-active),
.transport-routes-wrap :deep(.el-tabs__item:hover) {
  color: #e70012;
}

.transport-routes-wrap :deep(.el-tabs__active-bar) {
  background-color: #e70012;
  height: 4px;
  transform: scaleX(0.8);
}

.tab-cont-top {
  display: flex;
  justify-content: center;
  position: relative;
  margin-top: 48px;
}

.tab-cont-top .tab-tag-wrap {
}

.tab-cont-top .show-more {
  position: absolute;
  right: 0px;

  font-size: 24px;

  font-weight: 400;
  color: #999999;
  line-height: 33px;
}

.tab-cont-top .show-more span {
  vertical-align: middle;
}

.tab-cont-top .show-more .arrow-icon {
  width: 24px;
  height: 24px;
  vertical-align: middle;
}

.tab-tag-wrap :deep(.el-radio) {
  padding: 0 15px;
  height: 36px;
  line-height: 36px;

  border-radius: 18px;
  border: none;
}

.tab-tag-wrap :deep(.el-radio.is-checked) {
  background: linear-gradient(180deg, #f50029 0%, #ff6a76 100%);
}

.tab-tag-wrap :deep(.el-radio.is-checked .el-radio__label) {
  color: #fff;
}

.tab-tag-wrap :deep(.el-radio .el-radio__input) {
  display: none;
}

.tab-tag-wrap :deep(.el-radio .el-radio__label) {
  padding: 0;
  font-size: 24px;
}

.box_8 {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 16px;
  width: 512px;

  border: 1px solid rgba(238, 238, 238, 1);
  margin-bottom: 37px;
}

.text_17 {
  width: 456px;

  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 1);
  font-size: 22px;
  font-weight: bold;
  text-align: left;
  line-height: 30px;
  margin: 32px 0 0 28px;
}

.box_76 {
  width: 336px;
  height: 28px;
  margin: 12px 0 0 28px;
}

.text-wrapper_4 {
  background-color: rgba(243, 244, 246, 1);
  border-radius: 4px;
  height: 28px;
}

.text_18 {
  height: 22px;
  overflow-wrap: break-word;
  color: rgba(38, 98, 244, 1);
  font-size: 16px;
  font-family: PingFangHK-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 22px;
  margin: 3px 8px 0 8px;
}

.text-wrapper_5 {
  background-color: rgba(243, 244, 246, 1);
  border-radius: 4px;
  height: 28px;
  width: 132px;
}

.text_19 {
  width: 116px;
  height: 22px;
  overflow-wrap: break-word;
  color: rgba(38, 98, 244, 1);
  font-size: 16px;
  font-family: PingFangHK-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 22px;
  margin: 3px 0 0 8px;
}

.text-wrapper_50 {
  width: 433px;
  height: 25px;
  margin: 26px 0 0 28px;
}

.text_20 {
  width: 36px;
  height: 25px;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 18px;
  font-family: PingFangHK-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 25px;
}

.text_21 {
  width: 51px;
  height: 25px;
  overflow-wrap: break-word;
  color: rgba(68, 68, 68, 1);
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  white-space: nowrap;
  line-height: 25px;
  margin-left: 13px;
}

.text_22 {
  width: 36px;
  height: 25px;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 18px;
  font-family: PingFangHK-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 25px;
  margin-left: 38px;
}

.text_23 {
  width: 95px;
  height: 25px;
  overflow-wrap: break-word;
  color: rgba(68, 68, 68, 1);
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  white-space: nowrap;
  line-height: 25px;
  margin-left: 13px;
}

.text_24 {
  width: 72px;
  height: 25px;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 18px;
  font-family: PingFangHK-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 25px;
  margin-left: 31px;
}

.text_25 {
  width: 36px;
  height: 25px;
  overflow-wrap: break-word;
  color: rgba(68, 68, 68, 1);
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  white-space: nowrap;
  line-height: 25px;
  margin-left: 12px;
}

.text-wrapper_51 {
  width: 342px;
  height: 25px;
  margin: 15px 0 0 28px;
}

.text_26 {
  height: 25px;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 18px;
  font-family: PingFangHK-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 25px;
  margin: 0 10px 0 0;
}

.text_27 {
  width: 274px;
  height: 25px;
  overflow-wrap: break-word;
  color: rgba(68, 68, 68, 1);
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  white-space: nowrap;
  line-height: 25px;
}

.box_77 {
  width: 456px;
  justify-content: space-between;
  height: 52px;
  margin: 26px 0 27px 28px;
}

.text-wrapper_8 {
  height: 40px;
  overflow-wrap: break-word;
  font-size: 0;
  font-weight: bold;
  text-align: left;
  line-height: 28px;
  margin-top: 12px;
  white-space: nowrap;
}

.text_28 {
  width: 112px;
  height: 40px;
  overflow-wrap: break-word;
  color: rgba(231, 0, 18, 1);
  font-size: 20px;
  font-weight: bold;
  text-align: left;
  line-height: 28px;
}

.text_29 {
  width: 112px;
  height: 40px;
  overflow-wrap: break-word;
  color: rgba(231, 0, 18, 1);
  font-size: 28px;
  font-weight: bold;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
}

.text_30 {
  width: 112px;
  height: 40px;
  overflow-wrap: break-word;
  color: rgba(231, 0, 18, 1);
  font-size: 22px;
  font-weight: bold;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
}

.text_31 {
  width: 112px;
  height: 40px;
  overflow-wrap: break-word;
  color: rgba(231, 0, 18, 1);
  font-size: 20px;
  font-weight: bold;
  text-align: left;
  line-height: 28px;
}

.text_32 {
  width: 20px;
  height: 28px;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 20px;
  font-family: PingFangHK-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
  margin: 21px 0 0 16px;
}

.group_5 {
  width: 52px;
  height: 52px;
  background: url(~/assets/kf-gray.png) 100% no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}

.text-wrapper_9 {
  cursor: pointer;
  height: 52px;
  background: linear-gradient(180deg, #f50029 0%, #ff6a76 100%);
  border-radius: 16px;
  margin-left: 12px;
  width: 116px;
}

.text_33 {
  width: 72px;
  height: 25px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  white-space: nowrap;
  line-height: 25px;
  margin: 14px 0 0 22px;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

.flex-row {
  display: flex;
  flex-direction: row;
}
</style>
